import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";
import { IUser } from "../interfaces/ilogin";

@Injectable()
export class AppUserService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * get user by email address
     */
    getUser(): Observable<IUser> {
        return super.get(`/api/ApplicationUser`)
            .pipe(map((res: any) => {
                return res as IUser;
            }));
    }
}



